import { io } from 'socket.io-client';
import { BASE_URL } from '../src/components/Constant';

export const socket = io(BASE_URL);
